import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, CameraIcon } from 'lucide-react';
import { BookingType } from '../../types/booking';
import { fees } from '../../data/units';
import { formatNaira } from '../../utils/format';
const options: {
  id: BookingType;
  label: string;
  detail: string;
  icon: typeof BuildingIcon;
}[] = [{
  id: 'apartment',
  label: 'Apartment stay',
  detail: 'From ₦180,000 / night',
  icon: BuildingIcon
}, {
  id: 'photoshoot',
  label: 'Photoshoot',
  detail: `${formatNaira(fees.photoshootSession)} / 3 hours`,
  icon: CameraIcon
}];
export function BookingTypeToggle({
  value,
  onChange
}: {
  value: BookingType;
  onChange: (type: BookingType) => void;
}) {
  return <div role="radiogroup" aria-label="Booking type" className="grid grid-cols-2 gap-2 rounded-full bg-ivory-200 p-1.5" data-id="element-77" data-mp="he0qf29qztrv">
      {options.map(option => {
      const selected = option.id === value;
      return <button key={option.id} type="button" role="radio" aria-checked={selected} onClick={() => onChange(option.id)} className="relative flex items-center justify-center gap-2.5 rounded-full px-3 py-3 text-left sm:px-5" data-id="element-78" data-mp="7fb8xalrkbc5">
            {selected && <motion.span layoutId="booking-type" className="absolute inset-0 rounded-full bg-forest-700 shadow-soft" transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-79" data-mp="19l50voeql4qc" />}
            <option.icon size={17} className={`relative shrink-0 transition-colors duration-150 ${selected ? 'text-gold-300' : 'text-forest-500'}`} aria-hidden="true" data-id="element-80" data-mp="c08s9s5mzfuj" />
            <span className="relative" data-id="element-81" data-mp="lw2bfudv27la">
              <span className={`block whitespace-nowrap text-[14px] transition-colors duration-150 ${selected ? 'text-ivory-100' : 'text-forest-700'}`} data-id="element-82" data-mp="3udgkxueuyty3">
                {option.label}
              </span>
              <span className={`hidden text-[11px] transition-colors duration-150 sm:block ${selected ? 'text-ivory-200/70' : 'text-muted'}`} data-id="element-83" data-mp="ixd81zetywnp">
                {option.detail}
              </span>
            </span>
          </button>;
    })}
    </div>;
}